export {
  default as brickOven,
  ReactComponent as BrickOven,
} from '@assets/icons/features-and-amenities/brick-oven.svg'    
